<template lang='pug'>
  div#app.l-container
    GlobalHeader(
      v-on:currentUpdate='handleCurrentUpdate'
      :current-section='currentSection'
    )
    main.l-content
      router-view(
        @currentUpdate='handleCurrentUpdate'
        :currentSection='currentSection'
      )
    GlobalFooter
</template>

<script>
import GlobalHeader from './components/header';
import GlobalFooter from './components/footer';

export default {
  name: 'app',
  components: {
    GlobalHeader,
    GlobalFooter,
  },
  data() {
    return {
      currentSection: 1,
    };
  },

  methods: {
    handleCurrentUpdate(nextValue) {
      this.currentSection = nextValue;
    },
  },
};
</script>

<style lang='scss' src='./assets/scss/entry/home.scss'></style>



// WEBPACK FOOTER //
// App.vue?2ca70be5